import { Button, Dialog, DialogActions, DialogContent } from "@mui/material";
import React from "react";

function AlertDialogBox({
  open,
  setOpen,
  children,
  actionButton,
  closeActionButton,
}) {
  const handleClose = () => setOpen(false);

  return (
    <Dialog open={open}>
      <DialogContent>{children}</DialogContent>
      <DialogActions>
        {closeActionButton && (
          <Button onClick={handleClose}>{closeActionButton}</Button>
        )}
        {actionButton && <div onClick={handleClose}>{actionButton}</div>}
      </DialogActions>
    </Dialog>
  );
}

export default AlertDialogBox;
